export default {
	AjaxGetError(error) {
		var errormsg = 'Unknown error';
		if (error.response) {
			if (error.response.data.title) {
				errormsg = error.response.data.title;
			} else if (error.response.data) {
				errormsg = error.response.data ? error.response.data.error : `<i>${error.response.statusText}</i> <small>(${error.response.status})</small>`;
			} else {
				errormsg = `<i>${error.response.statusText}</i> <small>(${error.response.status})</small>`;
			}
		} else if (error.request) {
			errormsg = `Impossibile raggiungere il server`;
		} else {
			errormsg = error.message;
		}

		return errormsg;
	}
}